import { Fragment, useState, useEffect, useContext, useRef } from 'react';
import postulacionesParaAdminsServices from '../services/postulacionesParaAdminsServices';
import { errorClassification } from '../errorHandler';
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import {useReactToPrint} from 'react-to-print';
import { Link } from "react-router-dom";

const OrdenDeMerito = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const [postulaciones, setPostulaciones] = useState([]);
  const [ofertas, setOfertas] = useState({});
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if(authInformation.autenticado === true){
      if( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' ){
        obtenerPostulaciones(false);
      } else {
        obtenerPostulaciones(true);
      }
    } else if(authInformation.autenticado === false){
      obtenerPostulaciones(true);
    }
  }, [authInformation]);


  const obtenerPostulaciones = async (es_publico = false) => {
    try {
      const data = await postulacionesParaAdminsServices.ordenDeMerito(es_publico);

      const grupos = data.reduce((agrupados, item) => {
        const oferta_id = item.oferta_id;

        if (!agrupados[oferta_id]) {
          agrupados[oferta_id] = item.oferta.titulo;
        }

        return agrupados;
      }, {});

      setOfertas(grupos)

      setPostulaciones(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const actualizarEstadoOrdenDeMerito = async (postulacion_id, value) => {
    try {
      setSaving(true)
      const data = await resourcesServices.actualizarResource('postulaciones', postulacion_id, {postulacion: {orden_merito_es_publico: value}});

      const updatedPostulaciones = postulaciones.map(item =>
        item.id === data.id ? { ...item, orden_merito_es_publico: data.orden_merito_es_publico } : item
      );

      setPostulaciones(updatedPostulaciones)
      setSaving(false)

      // handleShowModal("Datos actualizados");
    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const handleChecked = (e) => {
    const { name, value, checked } = e.target;
    actualizarEstadoOrdenDeMerito(value, checked)
  }

  const listarPostulaciones = postulaciones && ofertas && Object.keys(ofertas).map((oferta) => {
    return (
      <>
        {
          <div key={oferta} className="mb-3">
          <h3>{ofertas[oferta]}</h3>
          <table className="table table-bordered table-sm mb-5">
            <thead>
              <tr>
                <th className="text-start" scope="col">Nombre</th>
                <th className="text-end" scope="col">Documento</th>
                <th className="text-end" scope="col">Antecedentes</th>
                <th className="text-end" scope="col">Examen Escrito</th>
                <th className="text-end" scope="col">Examen Oral</th>
                <th className="text-end" scope="col">Coloquio</th>
                <th className="text-end" scope="col">Puntaje</th>
                {
                  (authInformation.autenticado === true && ( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' )) && (
                    <th className="text-start" scope="col">Público</th>
                  )
                }
              </tr>
            </thead>
            <tbody>
              {
                postulaciones && postulaciones.filter(p => p.oferta_id == oferta).map((postulacion, index) => {
                  return(
                    <Fragment key={index}>
                    <tr className='text-end'>
                      <td className='text-start'>{postulacion.nombre_publico_de_usuario}</td>
                      <td>{postulacion.documento_publico_de_usuario}</td>
                      <td>{postulacion.antecedentes}</td>
                      <td>{postulacion.examen_escrito}</td>
                      <td>{postulacion.examen_oral}</td>
                      <td>{postulacion.coloquio}</td>
                      <td>{postulacion.puntaje}</td>
                      {
                        (authInformation.autenticado === true && ( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' )) && (
                          <td>
                            {saving ? (
                              <div>guardando...</div>
                            ) :
                            (
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  value={`${postulacion.id}`}
                                  name={`publico_${postulacion.id}`}
                                  type="checkbox"
                                  onChange={(e) => handleChecked(e)}
                                  checked={postulacion.orden_merito_es_publico}
                                  role="switch" />
                              </div>
                            )}

                          </td>
                        )
                      }
                    </tr>
                    {
                      postulacion.archivos_adjuntos_puntaje.length>0 && (
                        <tr className='text-end'>
                          <td colSpan={7}>
                            {
                              postulacion.archivos_adjuntos_puntaje.map((adjunto, idx) => (
                                <div key={idx}>
                                  <Link target='_blank' className='btn btn-success' to={adjunto.url}>Descargar {adjunto.nombre}</Link>
                                </div>
                              ))
                            }
                          </td>
                        </tr>
                      )
                    }

                    </Fragment>
                  )
                })
              }
            </tbody>
          </table>
          <button className="btn btn-dark btn-lg px-4" type="button" onClick={handlePrint} >Imprimir</button>
          </div>
        }
      </>
    )
  })

  return (
    <>
      <div ref={componentRef}>
        <h1>Orden de Mérito</h1>
        <div className="container">
            {listarPostulaciones}
        </div>
      </div>
    </>
  );
};

export default OrdenDeMerito;